import { updateLayoutItem } from 'entities/hallmap/model/hallmapThunk';
import { Table } from 'shared/lib/core';
import { useAppDispatch } from 'shared/lib/store';
import { toast } from 'react-toastify';
import { useCallback } from 'react';

export const useLayoutItems = () => {
	const dispatch = useAppDispatch();

	const updateLayoutConfig = useCallback(
		async (table: Table) => {
			if (!table.layout) {
				return;
			}

			const config: {
				x: number;
				y: number;
				rotation?: number;
			} = {
				...table.getPosition(),
			}

			if (table.angle !== 0) {
				config.rotation = table.angle
			}

			await dispatch(
				updateLayoutItem({
					id: table.layout.id,
					config,
				}),
			);

			toast.success(`Расположение стола ${table.name} изменено`);
		},
		[dispatch],
	);

	return {
		updateLayoutConfig,
	};
};
